import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  DateRangePicker, DateRangeStepper,
} from '../../../components';
import FilterWrapper from '../filter-wrapper';

const styles = {
  dateRangePicker: {
    width: '100%',
  },
};


class DateRangeFilter extends Component {
  render() {
    const {
      isAdvancedFilter, dateRange, setDateRange,
    } = this.props;

    const title = 'Von - Bis';

    return (
      <FilterWrapper title={title} height={1.5} isAdvancedFilter={isAdvancedFilter}>
        <DateRangePicker
          startDate={moment.unix(dateRange.startDate)}
          endDate={moment.unix(dateRange.endDate)}
          onDatesChanged={setDateRange}
          styles={styles.dateRangePicker}
          title={title}
        />
        <DateRangeStepper
          startDate={moment.unix(dateRange.startDate)}
          endDate={moment.unix(dateRange.endDate)}
          onDatesChanged={setDateRange}
        />
      </FilterWrapper>
    );
  }
}

DateRangeFilter.propTypes = {
  isAdvancedFilter: PropTypes.bool,
  dateRange: PropTypes.object,
  setDateRange: PropTypes.func,
};

DateRangeFilter.defaultProps = {
  isAdvancedFilter: false,
  dateRange: {
    startDate: 0,
    endDate: 0,
  },
  setDateRange: () => {},
};

export default DateRangeFilter;
